import { Button, Grid } from '@mui/material';
import { DataGrid, GridCellValue, GridColDef } from '@mui/x-data-grid';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFindAllSignupsQuery } from '../../api/api-hooks';
import ToggleSwitch from '../../components/ToggleSwitch';
import SignupTransferDialog from './SignupTransferDialog';

const Signups = () => {
  const { data: signups } = useFindAllSignupsQuery({});
  const [transferDialogOpen, setTransferDialogOpen] = useState<boolean>(false);
  const [clickedSignup, setClickedSignup] = useState<string | number>(0);
  const { push } = useHistory();
  if (signups === undefined) return null;
  const columns: GridColDef[] = [
    { field: 'id', hide: true },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'phone', headerName: 'Phone #', width: 150 },
    { field: 'address', headerName: 'Address', width: 200 },
    { field: 'email', headerName: 'Email', width: 200 },
    { field: 'analyzerSerial', headerName: 'Analyzer Serial', width: 200 },
    { field: 'company', headerName: 'Company', width: 200 },
    {
      field: 'buttons',
      headerName: ' ',
      width: 200,
      renderCell: (params) => {
        const handleClick = () => {
          const signupId: GridCellValue = params.getValue(params.id, 'id');
          if (typeof signupId === 'number' || typeof signupId === 'string')
            setClickedSignup(signupId);
          setTransferDialogOpen(true);
        };
        return (
          <Grid container direction='row' spacing={1}>
            <Grid item>
              <Button onClick={handleClick} variant='outlined' color='primary'>
                Process
              </Button>
            </Grid>
          </Grid>
        );
      },
    },
  ];
  return (
    <>
      <Grid container style={{ marginBottom: '1rem', marginTop: '4px' }}>
        <Grid item>
          <ToggleSwitch
            options={['Users', 'Signups']}
            onClicks={[
              () => {
                push('/users');
              },
              () => {
                push('/signups');
              },
            ]}
            startingOption='Signups'
          />
        </Grid>
      </Grid>
      <div style={{ paddingBottom: '1rem', width: '100%' }}>
        <DataGrid
          rows={signups}
          columns={columns}
          pageSize={100}
          disableSelectionOnClick
          disableColumnMenu={true}
          autoHeight
        />
      </div>
      {clickedSignup ? (
        <SignupTransferDialog
          dialogOpen={transferDialogOpen}
          setDialogOpen={setTransferDialogOpen}
          signupId={clickedSignup}
        />
      ) : null}
    </>
  );
};

export default Signups;
